// import { Component, OnInit } from '@angular/core';
// import { SharedComponent } from '../../shared/shared.component';
// import { Account } from '../model/account.model';
// import { Guid } from '../_helpers/guid';
// import { AccountService } from '../_services/domainservice/account.service';
// import { NgxSpinnerService, Spinner } from "ngx-spinner";
// import { AlertService } from '../_services/alert.service';
// import { ActivatedRoute, Router } from '@angular/router';
// import { HttpErrorResponse } from '@angular/common/http';
// import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
// @Component({
//   selector: 'app-recoverypassword',
//   templateUrl: './recoverypassword.component.html',
//   styleUrls: ['./recoverypassword.component.css']
// })
// export class RecoverypasswordComponent extends SharedComponent implements OnInit {
  // public breadcrumb: any;
  // cols!: any[];
  // Accountlist: Array<Account>;
  // newpassword: string;
  // account: Account = new Account;
  // Email: string;
  // constructor(private accountService: AccountService,
  //   readonly alertService: AlertService,
  //   private spinner: NgxSpinnerService,
  //   private route: Router,
  //   private router: ActivatedRoute)
  // {
  //   super();
  // }
  // ngOnInit() {
  //   this.Email = this.router.snapshot.queryParamMap.get('Email');

  // }
  // Password(e) {
  //   this.newpassword = e.target.value;
  // }
  // CheckConfirmPassword(e) {
  //   if (this.newpassword === e.target.value) {

  //   }
  //   else {
  //     this.alertService.warning('Pls Enter the Correct Password');
  //     e.target.value = "";
  //   }
  // }
  // ChangePassword()
  // {
  //   this.accountService.getAccountEmail(this.getBase64Encode(this.Email)).subscribe((getaccountdata): void => {
  //     this.account.itemState = 2;
  //     this.account.abgTechnologysAccountUId = getaccountdata.abgTechnologysAccountUId;
  //     this.account.name = getaccountdata.name;
  //     this.account.email = getaccountdata.email;
  //     this.account.password = this.newpassword;
  //     this.account.mobileNumber = getaccountdata.mobileNumber;
  //     this.account.createdByApp = getaccountdata.createdByApp;
  //     this.account.createdByUser = getaccountdata.createdByUser;
  //     this.account.createdOn = getaccountdata.createdOn;
  //     this.account.productUId = getaccountdata.productUId;
  //     this.account.clientRegistrationUId = getaccountdata.clientRegistrationUId;
  //     this.account.roleBasedLogedin = getaccountdata.roleBasedLogedin;
  //     this.account.loggedInUId = getaccountdata.loggedInUId;
  //     this.account.accessRoleUId = getaccountdata.accessRoleUId;
  //     this.account.abgTechnologysAccountId = getaccountdata.abgTechnologysAccountId;
  //     this.account.modifiedByApp = getaccountdata.clientRegistrationUId.toString();
  //     this.account.modifiedByUser = getaccountdata.abgTechnologysAccountUId.toString();
  //     this.account.otp = getaccountdata.otp;
  //     //this.setAuditFields(this.account);
  //     this.accountService.mergeAccount(this.account, 'Edit').subscribe((data): void => {
  //       this.alertService.success('Password Reset successfully');
  //       this.route.navigate(['/login'])

  //     })
  //   })

  // }



//   resetForm!: FormGroup;
//   submitted = false;
//   loading = false;
//   done = false;
//   tokenInvalid = false;
//   errorMessage = '';

//   private token = '';

//   passwordStrength = 0;
//   strengthClass = '';
//   showPassword = false;

//   constructor(
//     private readonly fb: FormBuilder,
//     private readonly route: ActivatedRoute,
//     private readonly router: Router,
//     private readonly accountService: AccountService
//   ) { super(); }

//   ngOnInit(): void {
//     this.token = this.route.snapshot.queryParamMap.get('token') || '';
//     if (!this.token) { this.tokenInvalid = true; }

//     this.resetForm = this.fb.group({
//       password: ['', [Validators.required, Validators.minLength(8)]],
//       confirmPassword: ['', Validators.required]
//     }, { validators: this.matchValidator });

//     // Optional: validate the token up-front so an expired link shows the
//     // "Link expired" panel immediately.
//     // this.accountService.validateResetToken(this.token).subscribe({
//     //   error: () => this.tokenInvalid = true
//     // });
//   }

//   get rf() { return this.resetForm.controls; }

//   private matchValidator(group: AbstractControl): ValidationErrors | null {
//     const p = group.get('password')?.value;
//     const c = group.get('confirmPassword')?.value;
//     return p && c && p !== c ? { mismatch: true } : null;
//   }

//   onPasswordChange(): void {
//     const v: string = this.resetForm.value.password || '';
//     let score = 0;
//     if (v.length >= 8) { score++; }
//     if (/[A-Z]/.test(v) && /[a-z]/.test(v)) { score++; }
//     if (/[0-9]/.test(v) && /[^A-Za-z0-9]/.test(v)) { score++; }
//     this.passwordStrength = score;
//     this.strengthClass = score <= 1 ? 'weak' : score === 2 ? 'medium' : 'strong';
//   }

//   submit(): void {
//     this.submitted = true;
//     this.errorMessage = '';
//     if (this.resetForm.invalid) { return; }

//     this.loading = true;
//     // TODO backend: resetPassword(token, newPassword) -> validate PasswordReset
//     // (not used, not expired), update ABGTechnologysAccount.Password, mark token used.
//     this.accountService.resetPassword(this.token, this.resetForm.value.password).subscribe({
//       next: () => { this.loading = false; this.done = true; },
//       error: (err: any) => {
//         this.loading = false;
//         if (err?.status === 410 || err?.status === 404) { this.tokenInvalid = true; }
//         else { this.errorMessage = err?.error || 'Could not update password. Please try again.'; }
//       }
//     });
//   }

// }



import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../_services/domainservice/login.service';
@Component({
  selector: 'app-recoverypassword',
  templateUrl: './recoverypassword.component.html',
  styleUrls: ['./recoverypassword.component.css']
})
export class RecoverypasswordComponent implements OnInit {
  form!: FormGroup;
  submitted = false;
  loading = false;
  errorMessage = '';

  constructor(
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly loginService: LoginService,
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  get f() { return this.form.controls; }

  submit(): void {
    this.submitted = true;
    this.errorMessage = '';
    if (this.form.invalid) { return; }

    this.loading = true;
    const { currentPassword, newPassword } = this.form.value;
    this.loginService.changePassword(currentPassword, newPassword).subscribe({
      next: () => {
        this.loading = false;
        // ChangePasswordAsync also calls RevokeAllSessionsAsync (AuthService.cs) — the tokens this
        // page is currently using are already dead server-side, so send the user back to a real
        // sign-in rather than pretending the current session still works.
        localStorage.clear();
        this.router.navigate(['/login']);
      },
      error: (err: any) => {
        this.loading = false;
        const code = err?.error?.code;
        this.errorMessage =
          code === 'PASSWORD_REUSED' ? "You've used this password recently. Choose a different one." :
            err?.error?.errors?.length ? err.error.errors.join(' ') :          
              'Could not change your password. Check your current password and try again.';
      },
    });
  }
}

//   resetForm!: FormGroup;
//   submitted = false;
//   loading = false;
//   done = false;
//   tokenInvalid = false;
//   errorMessage = '';

//   passwordStrength = 0;
//   strengthClass = '';
//   showPassword = false;

//   constructor(
//     private readonly fb: FormBuilder,
//     private readonly route: ActivatedRoute,
//     private readonly router: Router,
//     private readonly accountService: AccountService
//   ) {
//     super();
//   }

//   ngOnInit(): void {
//     const email =
//       this.route.snapshot.queryParamMap.get('email') ||
//       this.route.snapshot.queryParamMap.get('EmailId') ||
//       '';

//     this.resetForm = this.fb.group({
//       email: [email, [Validators.required, Validators.email]],
//       code: ['', [Validators.required, Validators.pattern(/^[0-9]{6}$/)]],
//       password: ['', [Validators.required, Validators.minLength(8)]],
//       confirmPassword: ['', Validators.required]
//     }, { validators: this.matchValidator });
//   }

//   get rf() {
//     return this.resetForm.controls;
//   }

//   private matchValidator(group: AbstractControl): ValidationErrors | null {
//     const p = group.get('password')?.value;
//     const c = group.get('confirmPassword')?.value;
//     return p && c && p !== c ? { mismatch: true } : null;
//   }

//   onPasswordChange(): void {
//     const v: string = this.resetForm.value.password || '';
//     let score = 0;
//     if (v.length >= 8) { score++; }
//     if (/[A-Z]/.test(v) && /[a-z]/.test(v)) { score++; }
//     if (/[0-9]/.test(v) && /[^A-Za-z0-9]/.test(v)) { score++; }
//     this.passwordStrength = score;
//     this.strengthClass = score <= 1 ? 'weak' : score === 2 ? 'medium' : 'strong';
//   }

//   submit(): void {
//     this.submitted = true;
//     this.errorMessage = '';

//     if (this.resetForm.invalid) {
//       return;
//     }

//     this.loading = true;

//     // this.accountService.resetPassword(
//     //   this.resetForm.value.email,
//     //   this.resetForm.value.code,
//     //   this.resetForm.value.password
//     // ).subscribe({
//     //   next: () => {
//     //     this.loading = false;
//     //     this.done = true;
//     //     setTimeout(() => this.router.navigate(['/login']), 1400);
//     //   },
//     //   error: (err: any) => {
//     //     this.loading = false;
//     //     this.errorMessage = this.getErrorMessage(err, 'Could not update password. Please try again.');
//     //   }
//     // });
//   }

//   private getErrorMessage(err: any, fallback: string): string {
//     if (typeof err?.error === 'string') {
//       return err.error;
//     }
//     if (typeof err?.error?.message === 'string') {
//       return err.error.message;
//     }
//     if (typeof err?.error?.code === 'string') {
//       return err.error.message || err.error.code;
//     }
//     return fallback;
//   }
// }
